//会社特有の休日情報を設定する
window.CustomDeliveryDatetime.settings = {...window.CustomDeliveryDatetime.settings ,
	ORDER_THRESHOLD_HOUR: 13,//締め時間
	SPECIAL_MAKER_LEAD_TIME:0,//◎メーカー特別リードタイム
	INITIAL_POSTCODE:"1000000",//初期郵便番号
	LEAD_TIME_MAX: 60
};
